/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_6f63e5a9"]'><div :class='["button-groupwith-context-demo"]'><cube-button-group direction="horizontal"><div :class='["button-groupwith-title"]'>图文结合示例</div><cube-button inline>操作</cube-button></cube-button-group></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_6f63e5a9"}'>
.button-groupwith-context-demo
  .cube-button-group
    display flex
    padding 20px 25px
    box-sizing border-box
    background-color #fff
    justify-content space-between
    align-items center
    border-radius 8px
  .button-groupwith-title
    line-height 27px
    font-size 21px
    color #282828
  .cube-btn
    padding 8px 26px
    font-size 16px
    line-height 24px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_6f63e5a9"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_6f63e5a9"}
  /** script content **/
  require("./button-group-with-context.mpx.js?isComponent&outputPath=components%2Fbutton-group-with-context6f63e5a9%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./button-group-with-context.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbutton-group-with-context6f63e5a9%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_6f63e5a9"],
    ctorType: "component",
    outputPath: "components/button-group-with-context6f63e5a9/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'view-desc':getComponent(require("../../components/desc/index.mpx?isComponent&outputPath=components%2Findex590d50a3%2Findex")),'cube-button-group':getComponent(require("../../../packages/mpx-cube-ui/src/components/button-group/index.mpx?isComponent&outputPath=components%2Findexb32f512a%2Findex")),'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>